export default __webpack_public_path__ + "c1ecdd07ce82032d6053bced281e7b2a.png";